import { Tooltip } from '@mui/material';

import { ActiveStatusLabel } from 'components/UIComponents';
import TableWithLazyLoad from 'components/base/TableWithLazyLoad/TableWithLazyLoad';
import CodeMP3FileForm from 'components/forms/CodeMP3FileForm';

import { MP3State } from 'context/MP3Context';

import { codeFileInfo } from 'helpers/codesHelper';

import { ICodesTable } from 'interfaces/Code/ICodesTable';
import { ITableColumn } from 'interfaces/ITableColumn';

import MP3PlayBlock from '../MP3PlayBlock';

const columns = [
  { dataField: 'code', text: 'Code' },
  { dataField: 'keyword', text: 'Keyword' },
  { dataField: 'isci1', text: 'ISCI #1' },
  { dataField: 'filename1', text: 'File #1 name' },
  { dataField: 'mp3Actions1', text: '' },
  { dataField: 'isci2', text: 'ISCI #2' },
  { dataField: 'filename2', text: 'File #2 name' },
  { dataField: 'mp3Actions2', text: '' },
  { dataField: 'isci3', text: 'ISCI #3' },
  { dataField: 'filename3', text: 'File #3 name' },
  { dataField: 'mp3Actions3', text: '' },
  { dataField: 'status', text: 'Status' },
];

interface Props {
  editAction: (id: number) => void;
  codesData: ICodesTable[];
  switchActivation: (codeId: number, active: boolean) => void;
  deleteAction: (codeId: number) => void;
  reloadData: () => void;
}

const ALL_EXCEPT_TABLE_HEIGHT = 484;
const MAX_ISCI_CODES_NUMBER = 3;
const tableContainerStyles = {
  maxHeight: window.innerHeight - ALL_EXCEPT_TABLE_HEIGHT,
};

const isciColumns = (item: ICodesTable, reloadData: () => void) => {
  const initializedObject: any = {};

  for (let i = 0; i < MAX_ISCI_CODES_NUMBER; i++) {
    initializedObject[`isci${i + 1}`] = '';
    initializedObject[`filename${i + 1}`] = '';
    initializedObject[`mp3Actions${i + 1}`] = '';
  }

  item.isci_codes.forEach((isci_code) => {
    initializedObject[`isci${isci_code.index + 1}`] = isci_code.isci;
    initializedObject[`filename${isci_code.index+1}`] = isci_code.audio_name ? (
      <Tooltip placement="top" arrow title={codeFileInfo(isci_code)}>
        <span>{isci_code.audio_name}</span>
      </Tooltip>
    ) : ('');
    initializedObject[`mp3Actions${isci_code.index+1}`] = isci_code.audio_name ? (
      <MP3PlayBlock code={item} isciCode={isci_code} onSuccess={reloadData} />
    ) : (
      <CodeMP3FileForm code={item} isciCode={isci_code} onSuccess={reloadData} />
    );
  });

  return initializedObject;
};


const ListOfSpotCreativeCodes = ({ editAction, codesData, switchActivation, deleteAction, reloadData }: Props) => {

  const preparedData = codesData.map((item: ICodesTable) => ({
    id: item.id,
    code: item.code,
    keyword: item.keyword,
    ...isciColumns(item, reloadData),
    status: <ActiveStatusLabel active={item.is_active} />,
    actions: [
      {
        name: item.is_active ? 'Deactivate' : 'Activate',
        action: () => switchActivation(item.id, !item.is_active),
      },
      { name: 'Delete', action: deleteAction },
    ].filter(Boolean),
  }));

  return (
    <>
      <MP3State>
        <TableWithLazyLoad
          name="codes"
          columns={columns as ITableColumn[]}
          data={preparedData}
          editAction={editAction}
          rowsAsLinks={false}
          tableContainerStyles={tableContainerStyles}
        />
      </MP3State>
    </>
  );
};

export default ListOfSpotCreativeCodes;
